<template>
  <b-row class="tenant-booking-container">
    <b-col lg="4" md="4" sm="12" cols="12" class="dash-element-image-container">
      <b-img fluid rounded :src="listingCoverImg" alt="Thumbnail"/>
    </b-col>
    <b-col lg="7" md="7" sm="12" cols="12" class="dash-element-details-container">
      <p class="dash-item-title">{{listingAddressFormatted}}</p>
      <p class="dash-item-subtitle">{{formatTime(bookingHolder.booking.periodStart)}} - {{formatTime(bookingHolder.booking.periodEnd)}}</p>
        <span class="stay-status" :class="getClass(bookingHolder.booking.status)">{{getDisplayStatus(bookingHolder.booking)}}</span>
      <p/>

      <b-container>
        <div class="dash-listing-toolbar">
          <md-button class="md-primary play-cta-button-flat" @click="redirectToChat">Chat</md-button>
          <md-button v-if="loadingListing"  class="md-icon-button">
            <md-icon><div class="loader-rolling-local"></div></md-icon>
          </md-button>
          <md-button v-else class="md-primary play-cta-button-flat" @click="viewBooking">View</md-button>
        </div>
      </b-container>
    </b-col>
    <error-snackbar
      :message="errorSnackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showErrorSnackbar"
      position="center"
      :isInfinity="false">
    </error-snackbar>
  </b-row>
</template>

<script>
  import {formatTimeToMonthDDYY} from '../../timeFunctions.js'
  import {getInternalListingPublic} from '../../listingsRepository.js'
  import {getCoverThumbnail} from '../../listings/images/imageService.js'
  import {getFormattedAddress} from '../../listings/location/locationService.js'
  import {mapState} from 'vuex'
  import Snackbar from '../../components/snackbar.vue'
  import {
    composeChatRedirectParams
  }from '../../chatRepository.js';
  import { BOOKING_STATUS, BOOKING_PAYMENT_STATUS } from "@/bookings/bookingUtil";

  export default {
    props: {
      bookingHolder:{
        type: Object,
        required: true
      }
    },
    components: {
      'error-snackbar': Snackbar
    },
    data() {
      return {
        listing: undefined,
        loadingListing: true,
        listingCoverImg: "",
        listingAddressFormatted: "",
        showErrorSnackbar: false,
        errorSnackbarMessage: "",
        BOOKING_STATUS,
      }
    },
    computed: {
      tenantStayIds(){
        return this.$store.getters.tenantStayIds
      },
      placeholder() {
        return require('../../assets/listing-hero-placeholder.png')
      },
    },
    created(){
      this.listingCoverImg = this.placeholder
      this.loadingListing = true
      if(this.bookingHolder){

        this.listing = this.bookingHolder.listing
        var coverImage = getCoverThumbnail(this.bookingHolder.listing.marketingDet.images)
        if(coverImage) this.listingCoverImg=coverImage
        else if(this.bookingHolder.listing.marketingDet.images[0]) this.listingCoverImg = this.bookingHolder.listing.marketingDet.images[0]

        var fAddress = getFormattedAddress(this.bookingHolder.listing.location)
        if(fAddress) this.listingAddressFormatted = fAddress
        else if(this.bookingHolder.listing.location.county)this.listingAddressFormatted = this.bookingHolder.listing.location.county
        this.loadingListing = false

      }
    },
    methods: {
      getClass(systemStatus){
        if(systemStatus === BOOKING_STATUS.accepted) return "acceptedStatus"
        if(systemStatus === BOOKING_STATUS.created) return "createdStatus"
        if(systemStatus === BOOKING_PAYMENT_STATUS.payment_cancelled) return "cancelledStatus"
        if(systemStatus === BOOKING_PAYMENT_STATUS.payment_failed) return "cancelledStatus"
        if(systemStatus === BOOKING_STATUS.declined) return "declinedStatus"
        if(systemStatus === BOOKING_STATUS.cancelled) return "cancelledStatus"
      },
      viewBooking(){
        this.$router.push({
          name: 'booking',
          params: {
            bookingId: this.bookingHolder.booking._id,
            booking: this.bookingHolder.booking,
            listing: this.listing,
            owner: this.bookingHolder.owner,
            tenant: this.bookingHolder.tenant,
            ownerViewing: false,
            redirect: "stays"
          }
        })
      },
      getDisplayStatus(booking){
        if((booking.status === BOOKING_STATUS.created && booking.paymentStatus === BOOKING_PAYMENT_STATUS.payment_success) || booking.status === BOOKING_STATUS.pending_owner_confirmation) return "Pending Confirmation"
        if(booking.status === BOOKING_STATUS.created && booking.paymentStatus != BOOKING_PAYMENT_STATUS.payment_success) return "Pending Payment"
        if(booking.status === BOOKING_STATUS.accepted) return "Confirmed"
        if(booking.paymentStatus === BOOKING_PAYMENT_STATUS.payment_cancelled) return "Payment cancelled"
        if(booking.paymentStatus === BOOKING_PAYMENT_STATUS.payment_failed) return "Payment failed"
        if(booking.status === BOOKING_STATUS.declined) return "Declined"
        if(booking.status === BOOKING_STATUS.cancelled) return "Cancelled"
      },
      redirectToChat(){
        this.$router.push({
          name: 'chat',
          params: composeChatRedirectParams(this.bookingHolder.booking.ownerUid, "", this.listingAddressFormatted)
        })
      },
      formatTime(dateString){
        return formatTimeToMonthDDYY(dateString)
      }
    }
  }
</script>
<style scoped>
  @import '../../assets/styles/dashboard.css';
  @import '../../assets/styles/global.css';
  @import '../../assets/styles/booking.css';
  @import '../../assets/styles/listings-view.css';

  .booking-request-content-container{
    padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stayPreview.vue